export default class UserPasswordChange {
  public CurrentPassword: string = '';
  public NewPassword: string = '';
  public ConfirmNewPassword: string = '';
}
